<template>
    <div class='container'>
        <visit-progress v-if='$route.params.name == "visit"'/>
        <contract-progress v-if='$route.params.name == "contract"'/>
        <promotion-rule v-if='$route.params.name == "promotion"'/>
        <invitation-rule v-if='$route.params.name == "invitation"'/>
        <cooperation-intro v-if='$route.params.name == "cooperation"' />
    </div>
</template>

<script>
    import VisitProgress from './_visit'
    import ContractProgress from './_contract'
    import PromotionRule from './_promotion'
    import InvitationRule from './_invitation'
    import CooperationIntro from './_cooperation'

    export default {
        components: {
            VisitProgress,
            ContractProgress,
            PromotionRule,
            InvitationRule,
            CooperationIntro
        }
    }
</script>

<style lang="less">
    .agency-poster {
        width: 80%;
        margin: 30px auto;
        display: block;
    }
</style>

